import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, ArrowLeft, Sparkles } from 'lucide-react';
import { t } from '../../lib/i18n';

const goldClass = 'flex-1 bg-[var(--lux-gold)] text-[var(--lux-ink)] hover:bg-[var(--lux-gold-2)] font-semibold active:scale-[0.98] transition-[background-color,transform] duration-200';

export const OnboardingNav = ({ step, totalSteps, loading, language, onBack, onNext, onSubmit }) => (
  <div className="flex gap-3 mt-6">
    {step > 0 && (
      <Button
        data-testid="onboarding-back-button"
        variant="outline"
        onClick={onBack}
        className="flex-1 bg-[var(--lux-panel)] border-white/10 text-white hover:bg-[var(--lux-panel-2)]"
      >
        <ArrowLeft className="w-4 h-4 mr-2" /> {t('back', language)}
      </Button>
    )}
    {step < totalSteps - 1 ? (
      <Button data-testid="onboarding-next-button" onClick={onNext} className={goldClass}>
        {t('next', language)} <ArrowRight className="w-4 h-4 ml-2" />
      </Button>
    ) : (
      <Button data-testid="onboarding-submit-button" onClick={onSubmit} disabled={loading} className={goldClass}>
        {loading
          ? <div className="w-5 h-5 border-2 border-[var(--lux-ink)] border-t-transparent rounded-full animate-spin" />
          : <span className="flex items-center gap-2"><Sparkles className="w-4 h-4" /> {t('startAnalysis', language)}</span>}
      </Button>
    )}
  </div>
);
